<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button v-if="!newTask" @click="deleteTask"><ion-icon :icon="trash"/></ion-button>
        </ion-buttons>
        <ion-title><HomeButton/> {{ t(...title) }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list lines="full">
        <ion-item>
          <ion-label position="floating">{{ t("form.task.title") }}</ion-label>
          <ion-input
              @ionChange="editTask.name=$event.target.value; "
              :value="editTask.name"
          ></ion-input>
        </ion-item>

        <ion-item>

          <ion-label position="floating">{{ t("form.task.category") }}</ion-label>
          <ion-select
              interface="action-sheet"
              @ionChange="updateCategory($event) "
              :value="editTask.category"
          >

            <ion-select-option v-for="category in sortedCategories()" v-bind:key="category.id" :value="category.id">
              {{ category.title }}
            </ion-select-option>
            <ion-select-option value="--own--">{{ t("form.options.category.own") }}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item>

          <ion-label position="floating">{{ t("form.task.tool") }}</ion-label>
          <ion-select
              multiple
              @ionChange="updateTools($event) "
              :value="editTask.usedTools"
          >

            <ion-select-option v-for="tool in sortedTools()" v-bind:key="tool.id" :value="tool.id">
              {{ tool.title }}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item v-if="editTask.category==='--own--'">
          <ion-label position="floating">{{ t("form.task.customCategory") }}</ion-label>
          <ion-input
              @ionChange="editTask.customCategory=$event.target.value; "
              :value="editTask.customCategory"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-label position="stacked">{{ t("form.task.difficulty") }}</ion-label>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <!-- Label only -->
                <ion-segment :value="editTask.difficulty"
                             @ionChange="editTask.difficulty=parseInt($event.target.value);">
                  <ion-segment-button :value="3">
                    <ion-label>{{ t("form.options.difficulty.easy") }}</ion-label>
                  </ion-segment-button>
                  <ion-segment-button :value="2">
                    <ion-label>{{ t("form.options.difficulty.semi") }}</ion-label>
                  </ion-segment-button>
                  <ion-segment-button :value="1">
                    <ion-label>{{ t("form.options.difficulty.hard") }}</ion-label>
                  </ion-segment-button>
                </ion-segment>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>

        <ion-item>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-label position="stacked">{{ t("form.task.priority") }}</ion-label>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <!-- Label only -->
                <ion-segment :value="editTask.priority" @ionChange="editTask.priority=parseInt($event.target.value);">
                  <ion-segment-button :value="3">
                    <ion-label>{{ t("form.options.priority.low") }}</ion-label>
                  </ion-segment-button>
                  <ion-segment-button :value="2">
                    <ion-label>{{ t("form.options.priority.semi") }}</ion-label>
                  </ion-segment-button>
                  <ion-segment-button :value="1">
                    <ion-label>{{ t("form.options.priority.high") }}</ion-label>
                  </ion-segment-button>
                </ion-segment>

              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
        <ion-item>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-label position="stacked">{{ t("form.task.duration") }}</ion-label>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <!-- Label only -->
                <ion-segment :value="editTask.duration" @ionChange="editTask.duration=parseInt($event.target.value);">
                  <ion-segment-button :value="15*60">
                    <ion-label>{{ t("form.options.duration.short") }}</ion-label>
                  </ion-segment-button>
                  <ion-segment-button :value="60*60">
                    <ion-label>{{ t("form.options.duration.semi") }}</ion-label>
                  </ion-segment-button>
                  <ion-segment-button :value="4*60*60">
                    <ion-label>{{ t("form.options.duration.long") }}</ion-label>
                  </ion-segment-button>
                </ion-segment>

              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>


        <ion-item>
          <ion-label position="stacked">{{ t('form.task.deadline') }}</ion-label>
          <ion-input type="datetime-local" :value="asDate(editTask.deadline).toISOString().replace(/:\d+\.\d+Z$/,'')" @ionChange="updateTime"/>
<!--          <ion-datetime :display-format="t('datetimeFormat')" picker-format="D.M.YY H:m"-->
<!--                        :value="asDate(editTask.deadline).toISOString()"-->
<!--                        @ionChange="editTask.deadline=new Date($event.target.value)"></ion-datetime>-->
        </ion-item>
        <ion-item>
          <ion-label position="floating">{{ t('form.task.description') }}</ion-label>
          <ion-textarea @ionChange="editTask.description=$event.target.value"
                        :value="editTask.description"></ion-textarea>
        </ion-item>
      </ion-list>
      <ion-button @click="cancel">{{ t("form.buttons.cancel") }}</ion-button>
      <ion-button @click="save">{{ t("form.buttons.ok") }}</ion-button>

    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {Category, I18nUtils, TaskUtils, Tool, ToolUtils} from '@/store/state';
import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonInput,
  IonLabel,
  IonList,
  IonItem,
  IonSegment,
  IonSegmentButton,
  // IonDatetime,
  IonTextarea,
  IonButton,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonGrid, IonRow, IonCol,
    IonIcon
} from "@ionic/vue";
import {NavigationGuardNext, RouteLocationNormalized, useRouter, useRoute} from "vue-router";
import {useI18n} from "vue-i18n";
import {watch, ref} from "vue";
import {Task, createEmptyTask} from "@/store/state";
import {useStore} from "@/store/store";
import firebase from "firebase";
import {trash} from "ionicons/icons";
import Timestamp = firebase.firestore.Timestamp;
import HomeButton from "@/components/HomeButton.vue";

const translations = {
  de: {
    titleNew: "Neue Aufgabe",
    titleEdit: "Bearbeite '{title}'",
    datetimeFormat: 'D.M.YY H:m',

    form: {
      buttons: {
        ok: "Speichern",
        cancel: "Abbrechen"
      },
      task: {
        tool: "Tool",
        title: "Titel",
        description: "Beschreibung",
        duration: "Umfang",
        priority: "Priorität",
        difficulty: "Schwierigkeit",
        category: "Kategorie",
        customCategory: "Eigene Kategorie",
        chooseCategory: "bitte wählen",
        deadline: "Zu erledigen bis",
        status: "Status"
      },
      options: {
        category: {
          own: "Eigene Kategorie"
        },
        difficulty: {
          easy: "Leicht",
          semi: "Mittel",
          hard: "Schwer",
        },
        priority: {
          low: "Niedrig",
          semi: "Mittel",
          high: "Hoch",
        },
        duration: {
          short: "15 Min.",
          semi: "1 Std.",
          long: "4 Std.",
        }
      }
    }
  }
}

export default defineComponent({
  name: "TaskForm",
  components: {
    HomeButton,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonContent,
    IonInput,
    IonLabel,
    IonList,
    IonItem,
    IonSegment,
    IonSegmentButton,
    // IonDatetime,
    IonTextarea,
    IonButton,
    IonPage,
    IonSelect,
    IonSelectOption,
    IonGrid, IonRow, IonCol,
    IonIcon
  },
  props: {
    taskId: {
      type: String,
      required: false,
    }
  },
  data() {


    return {}
  },
  computed: {
    title(): any {
      if (this.newTask) {
        return ["titleNew"]
      } else {
        return ["titleEdit", {title: this.editTask.name}]
      }

      //
    }
  },
  methods: {
    sortedTools(): Tool[] {
      return this.store.state.tools.map(tool => ToolUtils.translate(tool))
    },
    sortedCategories(): Category[] {
      console.log("sortedCategories");
      console.log(this.store);
      const result: Category[] = [];
      const mainCategories: Category[] = this.store.state.categories.filter((c: Category) => !c.parent).sort((a: Category, b: Category) => a.order - b.order);
      console.log(mainCategories);
      mainCategories.forEach(c => {

        result.push({...c, title: I18nUtils.toString(c.i18nTitle)});
        const subCategories = this.store.state.categories.filter((sc: Category) => sc.parent == c.id).sort((a: Category, b: Category) => a.order - b.order);
        subCategories.forEach(sc => {
          result.push({...sc, title: ' - ' + I18nUtils.toString(sc.i18nTitle)})
        })
      })
      return result;
    },
    asDate(t: Date | Timestamp | null): Date {
      return TaskUtils.asDate(t)
    },
    cancel() {
      this.router.go(-1)
    },
    toTimeline() {
      // this.router.go(-1);
      this.router.push({name: 'Timeline'})
    },
    save() {
      if (this.newTask) {
        this.store.dispatch('addTask', this.editTask).then(_ => this.router.go(-1))
      } else {
        this.store.dispatch('updateTask', this.editTask).then(_ => this.router.go(-1))
      }

    },
    updateTime(evt: any){
      console.log(evt,evt.target.value);
      this.editTask.deadline=new Date(evt.target.value+":00.000Z")
    },
    async deleteTask() {
      await this.store.dispatch('deleteTask', this.editTask.id)
      this.toTimeline()
    },
    updateTools($event: any){
      const usedTools: string[] = $event.target.value;
      this.editTask = {...this.editTask, usedTools};
      this.$forceUpdate();
    },
    updateCategory($event: any) {
      console.log($event.target.value);
      this.editTask = {...this.editTask, category: $event.target.value};
      this.$forceUpdate();
    },
    loadTask(id: string | null) {

      if (id) {

        const filtered = this.store.state.tasks.filter((t: Task) => t.id === id)
        if (filtered.length) {

          this.editTask = filtered.pop() ?? this.editTask;
          //clone!
          this.editTask = {...this.editTask};
          this.newTask = false;
        }
      } else {
        this.newTask = true
        this.editTask = createEmptyTask(60 * 15)

      }

    }

  },
  // beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  //   console.log("before",to,from)
  //   //this?.loadTask(to.params['taskId'])
  //   next(vm => vm)
  //
  // },
  // async beforeRouteUpdate(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  //   console.log("update",to,from)
  //   this.newTask = true
  //   this.editTask=createEmptyTask(60*15)
  //   try {
  //     await this.loadTask(to.params['taskId'])
  //   } catch (error) {
  //     console.log(error)
  //   }
  //   next();
  // },
  watch:
      {
        realTaskId: {
          handler(n: string, o: string) {
            console.log("watch handled", n);
            this.loadTask(n)
            // this.$forceUpdate();
          },
          immediate: true
        }
      },
  setup(props) {

    const router = useRouter();
    const {t, locale} = useI18n({messages: translations})
    const store = useStore();

    //scheiss workaround, bis das routing richtig funktioniert
    const route = useRoute();
    const realTaskId = route.params['taskId'];

    const editTask: Task = createEmptyTask(60 * 15);
    const newTask = true;
    const selectedCat = "";
    // watch(ref(props.taskId), (first, second) => {
    //   console.log("watch",first,second);
    //       loadTask(first);
    //     },
    //     {immediate: true}
    // );

    return {
      t,
      locale,
      router,
      store,
      editTask,
      newTask,
      realTaskId,
      selectedCat,
      trash
    }
  }
})
</script>

<style scoped>
ion-grid {
  --ion-grid-padding: 0;
}

ion-col {
  --ion-grid-column-padding: 0;
}
</style>